import React from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { PACKAGES, BENEFITS, T } from "@/lib/sponsorship";

export default function CartDrawer() {
  const { drawerOpen, setDrawerOpen, pkgId, benefitIds, lang, removeBenefit, clearPackage } = useCart();
  const navigate = useNavigate();
  if (!drawerOpen) return null;
  const t = T[lang];
  const pkg = PACKAGES.find(p => p.id === pkgId);
  const extras = benefitIds.map(id => BENEFITS.find(b => b.id === id)).filter(Boolean);
  const empty = !pkg && extras.length === 0;
  return (
    <div className="fixed inset-0 z-[100]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={()=>setDrawerOpen(false)} />
      <aside className="absolute right-0 top-0 h-full w-full max-w-md bg-[#020815] border-l border-[#022a67] flex flex-col">
        <div className="px-6 py-5 border-b border-[#022a67] flex justify-between items-center">
          <h2 className="font-display uppercase text-xl">{t.cartTitle}</h2>
          <button onClick={()=>setDrawerOpen(false)} className="p-2 hover:text-[#e77300]" data-testid="cart-close-btn"><X /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {empty && <p className="text-sm text-[#8ba3cc]">{t.cartEmpty}</p>}
          {pkg && (
            <div className="tele-card p-4">
              <div className="flex justify-between items-center"><div className="font-display uppercase">{pkg.name[lang]}</div><div className="text-[#e77300]">{lang==="pt"?`R$ ${pkg.brl.toLocaleString("pt-BR")}`:`US$ ${pkg.usd.toLocaleString("en-US")}`}</div></div>
              <button onClick={clearPackage} className="text-[10px] font-mono-alt uppercase tracking-widest text-white/60 hover:text-[#e77300] mt-2">{t.remove}</button>
            </div>
          )}
          {extras.map(b => (
            <div key={b.id} className="tele-card p-4 flex justify-between items-center">
              <span className="text-sm text-white/90">{b.name[lang]}</span>
              <div className="flex gap-2 items-center">
                <span className="text-[#e77300] text-sm">{lang==="pt"?`R$ ${b.brl.toLocaleString("pt-BR")}`:`US$ ${b.usd.toLocaleString("en-US")}`}</span>
                <button onClick={()=>removeBenefit(b.id)} className="text-[10px] text-white/50 hover:text-[#e77300] font-mono-alt uppercase tracking-widest">{t.remove}</button>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#022a67] p-6">
          <button onClick={()=>{setDrawerOpen(false); navigate("/sponsorship#finalize"); setTimeout(()=>document.getElementById("finalize")?.scrollIntoView({behavior:"smooth"}),100);}} disabled={empty} className="btn-racing primary w-full" data-testid="cart-submit-btn"><span>{t.finalize}</span></button>
        </div>
      </aside>
    </div>
  );
}
